import { all, call, put, takeLatest } from "redux-saga/effects";
import { GET_LIST_NHANVAY } from "../actions/NhanVay/actionTypes";
import {
  getListNhanVaySuccess,
  getListNhanVayFailure,
} from "../actions/NhanVay";
import NhanVayApi from "../service/nhanVayApi";

function* getListNhanVay(action) {
  try {
    const response = yield call(NhanVayApi.list, action.dataSearch);
    if (response.ok) {
      yield put(getListNhanVaySuccess(response.data));
    } else {
      yield put(getListNhanVayFailure());
    }
  } catch (error) {
    yield put(getListNhanVayFailure());
  }
}

function* watchGetRequest() {
  yield takeLatest(GET_LIST_NHANVAY, getListNhanVay);
}

export default function* sagas() {
  yield all([watchGetRequest()]);
}
